import React from 'react';
import QuotationList from '../components/QuotationList';

const SalesQuotations: React.FC = () => (
  <QuotationList quotationType="sales" title="Sotuv takliflari" icon="📈" />
);

export default SalesQuotations;
